var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKodinDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 234,
    viewBox: "0 0 216 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1374 230.808L38.1611 151.318L96.822 76.6167H144.445L75.6915 160.895L77.2684 140.464L147.598 230.808H97.1374ZM0 230.808V0H41.3149V230.808H0Z",
    fill: "#EAECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.454 234C182.885 234 176.683 231.446 171.847 226.338C167.011 221.231 164.593 214.952 164.593 207.503C164.593 200.055 167.011 193.776 171.847 188.669C176.683 183.561 182.885 181.007 190.454 181.007C197.813 181.007 203.91 183.561 208.746 188.669C213.582 193.776 216 200.055 216 207.503C216 214.952 213.582 221.231 208.746 226.338C203.91 231.446 197.813 234 190.454 234Z",
    fill: "#EAECF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKodinDot);
export default __webpack_public_path__ + "static/media/kodin-dot.db62748674aafa61210d60261f1ca14a.svg";
export { ForwardRef as ReactComponent };